import { AssessmentsSyncMessageComponent } from "./assessments-sync-message.component";
// import { downgradeComponent } from "@angular/upgrade/static";
// import { AssessmentsSyncMessageComponent } from "src/app/shared/assessments-sync-message/assessments-sync-message.component";
export const AssessmentsSyncMessageModule = angular
    .module('assessmentsSyncMessage', [])
    // .directive('assessmentsSyncMessage', downgradeComponent({component: AssessmentsSyncMessageComponent}))
    .component(AssessmentsSyncMessageComponent.selector, AssessmentsSyncMessageComponent.component)
    .name;
//# sourceMappingURL=assessments-sync-message.module.js.map